import * as React from 'react';
import { TPromoBanner } from './PromoBanner.types';
import { Button } from 'components';
import { useNavigate } from 'react-router';
import { APP_ROUTES } from '../../../../constants/routes';
import './PromoBanner.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const PromoBanner: TPromoBanner = () => {
  const localize = useLocalize();
  const navigate = useNavigate();

  const handleGoToCatalog = () => {
    navigate(APP_ROUTES.PRODUCTS);
  };

  return (
    <div className="promo-banner">
      <div className="promo-banner__content">
        <div className="promo-banner__left">
          <h1 className="promo-banner__title">
            {localize('home.promo.banner.title')}
          </h1>
          <Button
            variant="contained"
            className="promo-banner__button"
            onClick={handleGoToCatalog}
          >
            {localize('home.promo.banner.cta')}
          </Button>
          <p className="promo-banner__subtitle">
            {localize('home.promo.banner.subtitle')}
          </p>
        </div>
        <div className="promo-banner__right">
          <div className="promo-banner__phones">
            <div className="promo-banner__phone promo-banner__phone--1"></div>
            <div className="promo-banner__phone promo-banner__phone--2"></div>
            <div className="promo-banner__phone promo-banner__phone--3"></div>
          </div>
          <h2 className="promo-banner__right-title">
            {localize('home.promo.banner.right.title')}
          </h2>
        </div>
      </div>
      <div className="promo-banner__dots">
        <span className="promo-banner__dot promo-banner__dot--active"></span>
        <span className="promo-banner__dot"></span>
        <span className="promo-banner__dot"></span>
      </div>
    </div>
  );
};
